import { ResourceCodeEnums, UserTypeEnum } from "@/api/dmp_common/interface";
import { navigationMenuGroupMap } from "views/menu_layout/layout/config";

export interface NavigationItem {
  name?: string;
  url?: string;
  children?: string[];
  resourceCode?: ResourceCodeEnums;
  isDivider?: boolean;
}

export const navigationList: NavigationItem[] = [
  {
    name: "首页",
    url: "/home",
    resourceCode: ResourceCodeEnums.HOME,
  },
  {
    name: "人群资产",
    url: "/crowd",
    resourceCode: ResourceCodeEnums.CROWD,
  },
  {
    name: "生意",
    url: "/business",
    resourceCode: ResourceCodeEnums.BUSINESS,
  },
  {
    name: "活动与推广",
    url: "/activity_promotion",
    resourceCode: ResourceCodeEnums.ACTIVITY_PROMOTION,
  },
  {
    name: "市场洞察",
    url: "/market_insight",
    resourceCode: ResourceCodeEnums.MARKET_INSIGHT,
  },
  {
    name: "工具",
    url: "/tool",
    resourceCode: ResourceCodeEnums.TOOL,
  },
];

/** 每个导航对应的导航信息和这个导航下的菜单项 */
export const navigationListWithMenuList = navigationList.map((item) => {
  return {
    ...item,
    menuList:
      navigationMenuGroupMap[item.resourceCode]
        ?.map((menuGroup) => menuGroup.menuItemList)
        ?.flat() || [],
  };
});

/* 重定向到首页 **/
export const onRedirect = (pageUrl = "/") => {
  window.location.href = pageUrl;
};

export const HELP_CENTER_URL_MAP = {
  [UserTypeEnum.BRAND]: "https://shuyuan.pinduoduo.com/courseDetail/1513",
  [UserTypeEnum.SUPER]: "https://shuyuan.pinduoduo.com/courseDetail/1513",
  [UserTypeEnum.NORMAL]: "https://shuyuan.pinduoduo.com/courseSeries/40",
  [UserTypeEnum.ADVANCED]: "https://shuyuan.pinduoduo.com/courseSeries/38",
  [UserTypeEnum.MIDDLE]: "https://shuyuan.pinduoduo.com/courseSeries/39",
};
